import React, { useContext } from "react";
import { TripsPicker } from "./TripsPicker";
import { ToolsContext } from "../../ToolsContext";
import { TripPropertyEditor } from "./TripsPropertyEditor";
import { TripsStopTimesEditor } from "./TripsStopTimesEditor";


export function Trips() {
    const tool = useContext(ToolsContext);

    let panelHeight = '82vh';

    let Panel;


    return (
        <>
            <div style={{ height: panelHeight }}>
                {
                    (tool.propertyEditor == null) ? 
                        <TripsPicker className="flex align-content-center" />
                    :
                        <>
                            <TripPropertyEditor key={tool.propertyEditor.edit.trip_id} GTrip={tool.propertyEditor.edit}></TripPropertyEditor>
                        </>
                }
            </div>
        </>
    );
}